import { render, staticRenderFns } from "./SpinnerOct.vue?vue&type=template&id=2a781b44&scoped=true&"
import script from "./SpinnerOct.vue?vue&type=script&lang=js&"
export * from "./SpinnerOct.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerOct.vue?vue&type=style&index=0&id=2a781b44&prod&scoped=true&lang=css&"
import style1 from "./SpinnerOct.vue?vue&type=style&index=1&id=2a781b44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a781b44",
  null
  
)

export default component.exports